import Service from "../../../Services/index";
import moment from "moment";

const Order = {
    namespaced: true,
    state: {
        status_create_invoice : null,
        orderForm: {
            customer: null,
            transportation: null,
            transport_type: null,
            transport_type_name : "",
            details: [],
            status: 1,
            date: "",
            transport_type_id : null,
            note: null,
            status_have_old : false,
            status_payment : false,
            status_transport_other : false,
            customer_other: null,
            customer_other_id : "",
            other_price : "",
            other_price_form : null,
            remark : "",
            status_return : null,
            status_confirm : null,
            status_before_transport : null,
            status_tax_receipt : null,
            user_id : "",
            status_receive : null,
            discount_special: "",
            other_discount : '',
            order_transport_details : [],
            status_foam_discount : false,
            status_glass_discount : false,
            status_not_pay : false,
            status_sale_receive : false,
        },
        search: {
            order_id: "",
            date: [],
            status: "",
            transport_type: "",
            sale: "",
            customer : "",
            product : null,
        },
        promotion_detail: null,
        product_promotion_other : [],
        max_discount : 0,
        discount_price :[
            {value:null ,text:"เลือกราคาลดพิเศษ"},
            {value:1 ,text:"+1"},
            {value:2 ,text:"+2"},
            {value:3 ,text:"+3"},
            {value:4 ,text:"+4"},
            {value:5 ,text:"+5"},
        ],
        search_order : {
            sale : null,
            customer : null,
            date: "",
            month: "",
            year: "",
            range:null,
        },
    },
    mutations: {
        SET_ORDER_FORM: (state, res) => {
            state.orderForm = res;
        },
        GET_PROMOTION: (state, res) => {
            state.promotion_detail = res;
        },
        GET_PROMOTION_DETAILS: (state, res) => {
            state.orderForm.details = res;
        },
        SET_DETAILS : (state,res)=>{
            if(res.length > 0){
                state.orderForm.details = res;
            }
        },
        SET_PRODUCT_PROMOTION_OTHER : (state,res)=>{
            state.product_promotion_other = res.product;
            state.max_discount = res.max_discount;
        },
        CLEAR_FORM_DATA: (state,order_number) => {
            console.log('clear order data');
            const currentDate = moment().format("YYYY-MM-DD");
            state.orderForm = {
                id : '',
                order_id : order_number,
                customer: null,
                transportation: null,
                transport_type: null,
                details: [],
                status: 1,
                date: currentDate,
                transport_type_id : null,
                note: null,
                status_have_old : false,
                status_payment : false,
                status_transport_other : false,
                customer_other: null,
                customer_other_id : "",
                other_price : "",
                other_price_form : null,
                remark : "",
                status_return : null,
                transport_type_name : "",
                status_confirm : null,
                status_before_transport : null,
                status_tax_receipt : null,
                status_receive : null,
                discount_special : "",
                user_id : "",
                order_transport_details : [],
                other_discount : '',
                status_foam_discount : false,
                status_glass_discount : false,
                status_not_pay : false,
                status_sale_receive : false,
            };
            state.product_promotion_other = [];
            state.max_discount = [];

        },
        ADD_PRODUCT: (state, data) => {
            state.orderForm.details = [
                ...state.orderForm.details,
                {
                    ...data
                }
            ];
        },
        ADD_STATUS: (state, data) => {
            state.orderForm.details = [
                ...state.orderForm.status,
                {
                    ...data
                }
            ];
        },
        REMOVE_PRODUCT: (state, index) => {
            state.orderForm.details = state.orderForm.details.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                order_id: "",
                date: [],
                status: "",
                transport_type: "",
                sale: "",
                customer : "",
            },
            state.search_order = {
                customer : null,
                date: "",
                month: "",
                year: "",
                range:null,
            }
        },
        GET_DISCOUNT_PRICE : (state)=>{
            state.discount_price = [
                {value:0 ,text:"เลือกราคาลดพิเศษ"},
                {value:1 ,text:"-1"},
                {value:2 ,text:"-2"},
                {value:3 ,text:"-3"},
                {value:4 ,text:"-4"},
                {value:5 ,text:"-5"},
            ];
        },
        SET_STATUS_CREATE_INVOICE : (state,res)=>{
            state.status_create_invoice = res;
        }
    },
    actions: {
        setOrders({commit}, page = 1) {
            return Service.order.getOrder(page);
        },
        setOrderForm({commit},data){
            commit("SET_ORDER_FORM",data);
        },
        showOrder({commit}, id) {
            return Service.order.showOrder(id).then(response => {
                commit("SET_ORDER_FORM", response);
            });
        },
        clearFormData({commit}) {
            return Service.order.generateDO().then(res=>{
                commit('CLEAR_FORM_DATA',res);
            });
        },
        addProduct({commit}, data) {
            commit("ADD_PRODUCT", data);
        },
        addOrderStatus({commit}, data) {
            commit("ADD_STATUS", data);
        },
        removeProduct({commit}, index) {
            commit("REMOVE_PRODUCT", index);
        },
        createInvoiceFromOrder({commit,dispatch, state},order_id) {
            let details = [];
            return Service.order.orderProductForOpenInvoice(order_id).then(order_details=>{
                if(order_details){
                    order_details.forEach(detail=>{
                        if(detail.quantity > 0 && detail.product){
                            details.push(detail);
                        }
                    });
                    dispatch(
                        "Invoice/setInvoice",
                        {
                            customer: state.orderForm.customer,
                            order_id: state.orderForm.id,
                            details: details,
                            order_number: state.orderForm.order_id,
                            status: null,
                            status_have_old : state.orderForm.status_have_old,
                            status_payment : state.orderForm.status_payment,
                            status_transport_other : state.orderForm.status_transport_other,
                            other_price_form : state.orderForm.other_price_form,
                            other_price : state.orderForm.other_price,
                            customer_other : state.orderForm.customer_other,
                            remark : state.orderForm.remark,
                            status_return : state.orderForm.status_return,
                            transportation : state.orderForm.transportation,
                            transportation_id : state.orderForm.transportation_id,
                            transport_type_name :state.orderForm.transport_type_name,
                            transport_type_id : state.orderForm.transport_type_id,
                            status_confirm : state.orderForm.status_confirm,
                            status_before_transport : state.orderForm.status_before_transport,
                            status_tax_receipt : state.orderForm.status_tax_receipt,
                            status_receive : state.orderForm.status_receive,
                            discount_special : state.orderForm.discount_special,
                            order_transport_details : state.orderForm.order_transport_details,
                            other_discount : state.orderForm.other_discount,
                            status_foam_discount : state.orderForm.status_foam_discount,
                            status_glass_discount : state.orderForm.status_glass_discount,
                            status_not_pay : state.orderForm.status_not_pay,
                            status_sale_receive : state.orderForm.status_sale_receive,
                        },
                        {root: true}
                    );
                }
                commit('SET_STATUS_CREATE_INVOICE',order_details)
            })
        },
        save({commit, state}, id) {
            const data = {
                customer_id: "",
                sale_id: "",
                transport_type_id: "",
                transportation_id: "",
                order_status_id: 1,
                date: state.orderForm.date,
                order_id: "",
                details: state.orderForm.details.map(detail => ({
                    ...detail,
                    product_id: detail.product ? detail.product.id : null
                })),
                note: state.orderForm.note,
                status_have_old : state.orderForm.status_have_old,
                status_payment : state.orderForm.status_payment,
                status_transport_other : state.orderForm.status_transport_other,
                other_price : state.orderForm.other_price,
                other_price_form : state.orderForm.other_price_form,
                customer_other_id : state.orderForm.customer_other_id,
                remark : state.orderForm.remark,
                status_return : state.orderForm.status_return,
                status_confirm : state.orderForm.status_confirm,
                status_before_transport : state.orderForm.status_before_transport,
                status_tax_receipt : state.orderForm.status_tax_receipt,
                status_receive : state.orderForm.status_receive,
                discount_special : state.orderForm.discount_special,
                other_discount : state.orderForm.other_discount,
                user_id : state.orderForm.user_id,
                order_transport_details : state.orderForm.order_transport_details,
                status_foam_discount : state.orderForm.status_foam_discount,
                status_glass_discount : state.orderForm.status_glass_discount,
                status_not_pay : state.orderForm.status_not_pay,
                status_sale_receive : state.orderForm.status_sale_receive,
            };
            //transportation
            if (state.orderForm.transportation !== null) {
                data.transportation_id = state.orderForm.transportation.id
            }
            //customer
            if(state.orderForm.customer){
                data.customer_id = state.orderForm.customer.id;
            }
            //sale
            if(state.orderForm.customer && state.orderForm.customer.sale){
                data.sale_id = state.orderForm.customer.sale.id;
            }
            //transport_type
            if(state.orderForm.transport_type){
                data.transport_type_id = state.orderForm.transport_type.id;
            }
            if (!id) {//create
                return Service.order.createOrder(data);
            } else {
                data.order_id = state.orderForm.order_id;
                data.order_status_id = state.orderForm.order_status_id;
                return Service.order.updateOrder(id, data);
            }
        },
        delete({commit}, id) {
            return Service.order.deleteOrder(id);
        },
        search({commit}, {page = "", search}) {
            return Service.order.searchOrder(page,search);
        },
        promotionOrder({commit}, data) {
            return Service.order.PromotionOrder(data).then(res => {
                console.log("get one data promotion");
                commit("GET_PROMOTION", res);
            })
        },
        promotionOrderMultiple({commit}, data) {
            return Service.order.PromotionOrderMultiple(data).then(res => {
                console.log("get multiple data promotion");
                commit("GET_PROMOTION_DETAILS", res);
            })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        },
        getOrderBefore({commit},data){
            return Service.order.getOrderBefore(data.customer_id,data.transport_type_id).then(res=>{
                // commit("SET_DETAILS",res);
            });
        },
        //promotion other
        getProductByPromotionOther({commit},sale_id){
            return Service.order.getProductByPromotionOther(sale_id).then(res=>{
                commit("SET_PRODUCT_PROMOTION_OTHER",res);
            })
        },
        setDiscountPrice({commit}){
            commit("GET_DISCOUNT_PRICE")
        },
        changeStatusOrder({commit},data){
            return Service.order.changeStatusOrder(data);
        },
        getOrderTransportPrice({commit},data){
            return Service.order.getOrderTransportPrice(data);
        },
    }
};

export default Order;
